<template>
  <v-data-table :headers="headers" :items="localHistories" item-key="id" class="elevation-1" mobile-breakpoint="1024" :items-per-page="-1" disable-sort>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>履歴</v-toolbar-title>
        <v-dialog v-model="dialogDelete" persistent>
          <v-form>
            <v-card>
              <v-card-title>
                <span class="text-h5">この履歴を削除してもよろしいですか？</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.locationName" label="保管場所" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.categoryName" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.itemName" label="品目名" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.expirationDate" label="有効期限" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.entryDate" label="登録日" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.entryType" label="登録タイプ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedHistory.additionalQty" label="消費数" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedHistory.remainingQty" label="在庫数量" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="editedHistory.unitPurchasePrice" label="購入単価" type="number" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedHistory.store" label="購入店" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localDeleteHistory">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.categoryName`]="{ item }">
      <v-chip :color="getColor(item.categoryColor)" dark>
        {{ item.categoryName }}
      </v-chip>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon @click="openDelete(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogDelete: false,
      headers: [
        { text: "保管場所", value: "locationName" },
        { text: "カテゴリ", value: "categoryName" },
        { text: "品目名", value: "itemName" },
        { text: "有効期限", value: "expirationDate", align: "center" },
        { text: "登録日", value: "entryDate", align: "center" },
        { text: "登録タイプ", value: "entryType" },
        { text: "消費数", value: "additionalQty", align: "end" },
        { text: "在庫数量", value: "remainingQty", align: "end" },
        { text: "購入単価", value: "unitPurchasePrice", align: "end" },
        { text: "購入店", value: "store" },
        { text: "履歴削除", value: "action", align: "center" },
      ],
      localHistories: [],
      editedHistory: {
        id: "",
        locationName: "",
        categoryName: "",
        itemName: "",
        expirationDate: "",
        entryDate: "",
        entryType: "",
        additionalQty: 0,
        remainingQty: 0,
        unitPurchasePrice: "",
        store: "",
      },
      defaultHistory: {
        id: "",
        locationName: "",
        categoryName: "",
        itemName: "",
        expirationDate: "",
        entryDate: "",
        entryType: "",
        additionalQty: 0,
        remainingQty: 0,
        unitPurchasePrice: "",
        store: "",
      },
    };
  },
  created() {
    this.localHistories = this.$store.state.histories;
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    getColor(color) {
      switch (color) {
        case "青":
          return "blue";
        case "緑":
          return "green";
        case "橙":
          return "orange";
        case "灰":
          return "grey";
        case "黒":
          return "black";
        case "":
          return "transparent";
      }
    },
    openDelete(item) {
      this.editedHistory = Object.assign({}, item);
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedHistory = Object.assign({}, this.defaultHistory);
      });
    },
    localDeleteHistory() {
      this.deleteHistory(this.editedHistory.id);
      this.closeDelete();
    },
    ...mapActions(["deleteHistory"]),
  },
};
</script>

<style></style>
